/**
 * @file Service Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-07-02 Baidu
 */

import React from 'react';
import {connect} from 'react-redux';

import './index.less';

class Service extends React.Component {
    render() {
        const specialTip1 = '1.在您（及您的用户）开始使用本平台提供的相关服务（“本服务”或“本平台服务”）之前，'
            + '请您务必（并促使您的用户务必）认真阅读并充分理解本《短网址用户协议》的每一条款、您'
            + '（及您的用户）开通或使用某项服务时的附加条款以及百度不时发布或修订的相关协议（统称为“本协议”）'
            + '。同时，您（及您的用户）还应仔细阅读并充分理解百度的知识产权声明、免责声明、权利声明、'
            + '隐私权保护声明、网民权益保障声明等系列声明（地址：https://www.baidu.com/duty/ ）。'
            + ' 在本协议中，请您务必（并应促使您的用户务必）特别注意及重点阅读与您（及您的用户）'
            + '的权利及义务密切相关的条款，此类条款可能以粗体的方式标识，包括但不限于免除或者限制责任的条款。';
        const  specialTip2 = '2.如果您（及您的用户）使用本服务，您应当（并促使您的用户应当）完全接受本'
            + '协议的全部约定或规定。如您（或您的用户）不同意本协议及/或随时对其的修改，请勿访问本平台或使'
            + '用本服务，您（及您的用户）可通过从产品中终止使用本平台所提供的相关服务来取消“服务”。一旦您'
            + '（及您的用户）开始使用本服务，就视为您（及您的用户）已经了解并完全同意本协议及百度'
            + '系列声明的各项内容及百度对其随时作出的修改，同时还表明您（及您的用户）已经完全同意百'
            + '度已经完全履行了相关的提示义务和说明义务。您应确保您（并应促使您的用户确保其自身）有'
            + '充分的权利、权力、权限及能力以同意及履行本协议。';
        const  specialTip3 = '3.百度有权不时对本协议进行修订，且无需事先及单独通知您（或您的用户）。如果本协议发生'
            + '变动，百度将在其网站上公布修订后的协议。您充分理解并同意（并应促使您的用户充分理解并'
            + '同意），如果您（及您的用户）在修订后的协议公布后继续使用本服务，即视为您（及您的用户）'
            + '同意修订后的协议。';
        const serviceIntroDefine = '定义：本服务由百度短网址（DWZ），提供专业的网址缩短服务，具有稳定、快速、'
            + '安全的特点，提供网址缩短、批量缩短、网址还原、数据报表、开放API接口等服务。';
        const rightDeclare = '本协议未明示向您（及您的用户）授权的其他一切权利仍由百度保留，本协议未授予您'
            + '（及您的用户）任何其他未明示的权利。如您（及您的用户）使用其他权利，您（及您的用户）需要及时联系'
            + '百度，事先获得百度的书面许可，并与百度签订书面协议。百度如果未行使前述任何权利，并不构成对该权利的放弃。';
        const stopService = '除非您（或您的用户）与百度达成的书面协议中另有约定，百度有权随时修改、暂停'
            + '或终止本服务或其中任何一部分，也有权随时修改、暂停或终止您（及您的用户）对本服务的使用而无须'
            + '事先声明，包括但不限于百度可以随时自行决定限制您（或您的用户）使用服务的次数、数据量等。';
        const usePrinciple1 = '1. 您需保证（并应促使您的用户保证）您（及您的用户）对本服务的使用'
            + '不违反国家各项法律法规的规定，且不侵害任何第三方权益，该如因此造成任何后果及损失，由您'
            + '及您的用户）自行承担全部责任。';
        const usePrinciple2 = '您充分理解并同意（并应促使您的用户充分理解并同意），您（及您的用户）'
            + '在使用本服务时，应当遵守所有中华人民共和国的法律、法规、规章制度、规范、政策、行政命令、'
            + '强制标准及行业标准等（统称为“法律法规”）。除非法律法规允许且百度事先书面许可，您（及您的'
            + '用户）不得从事以下活动，也不得同意、授权或指示任何第三人从事包括但不限于以下内容的活动：';
        const  usePrinciple51 = '本平台对每位用户的服务具有一定的限制，相关服务达到限制后，您'
            + '了解并同意在您尚未满足本协议规则之前，我们将可能中断／终止您（或您的用户）的服务正常使用。';
        const usePrinciple52 = '百度短网址采用点数来计费，详细服务和售卖规则，参见：';
        const usePrinciple6 = '百度短网址会检测用户提交的长链接是否被百度安全检测收录，已收录的'
            + '链接可正常进行网址缩短。未被收录的链接，若链接不存在安全隐患大约在15分钟之内被百度安全'
            + '检测收录，收录后可正常使用百度短网址服务。';
        const usePrinciple7 = '7. 您充分理解并同意（并应促使您的用户充分理解并同意），您（及您的'
            + '用户）对自己使用本服务的一切行为及由此产生的一切结果负责，包括但不限于您（及您的用户）所'
            + '发表的任何内容、提供的任何服务以及由此产生的任何后果。您（及您的用户）应对本服务的内容应'
            + '自行判断并决定是否使用，并承担因使用本服务及其相关内容而引起的所有风险，包括因对本服务及'
            + '其内容的真实性、完整性、准确性、及时性及实用性的依赖而产生的风险。百度不对此提供任何担保'
            + '和保证，不对因前述风险而导致的任何后果或损失对您（或您的用户）承担责任。\n'
            + '如果您（或您的用户）违反了法律法规或本协议，百度有权依据合理判断对违反法律法规或本协议的'
            + '行为作出处理，并保留对该违反行为采取法律所能提供的所有补救手段的权利。百度有权对违反法律'
            + '法规及本协议的任何用户调查并采取适当的法律行动，包括但不限于民事诉讼等。百度有权根据违法'
            + '违规行为的严重程度，将上述违法违规行为的线索和您（或您的用户）的个人信息报告司法机关或其'
            + '他执法机关，并配合司法机关或其他执法机关进行的调查、听证、起诉等。您（或您的用户）应当自'
            + '行承担由此产生的任何法律责任。';
        const intellPropAndData1 = '1. 百度是本服务及其呈现内容以及任何其他相关内容的知识产权的完整和全部的合法权利人。'
            + '您充分理解并同意（并应促使您的用户充分理解并同意），您（及您的用户）仅拥有依照本协议约定'
            + '华人民共和国法律法规和相应的国际条约保护，百度享有上述知识产权。';
        const intellPropAndData2 = '2. 未经百度或相关权利人书面同意，您不得（并应促使您的用户保证不会）为任何商业或非'
            + '商业目的自行或许可任何第三方实施、利用、转让上述知识产权。';
        const intellPropAndData3 = '3. 您充分理解并同意（并应促使您的用户充分理解并同意），本服务的呈现内容中可能百度'
            + '、其关联公司及其合作伙伴的任何版权标识、商标、服务标记、标识、商号、企业名称、域名及其他'
            + '明显的标志，您不得（并应促使您的用户保证不会）以任何方式进行删除、掩藏、修改或替换该等信息或者标志。';
        const intellPropAndData4 = '4. 您不得（并应促使您的用户保证不会）以任何方式删除、掩藏、修改或替换本服务及'
            + '呈现内容中所附的或包含的任何专有权利声明（包含但不限于著作权、商标权、专利权、所有权声'
            + '明等）、其他任何链接或公告等。';
        const intellPropAndData5 = '5. 您同意（并应取得您的用户事先同意）在此授予百度免费的、永久性的'
            + '、不可撤销的、非独家的和不可转让的权利和许可，在本协议期限内使用您（及您的用户）的标志或行为'
            + '来宣传您（及您的用户）对本服务的使用。';
        const intellPropAndData6 = '6. 平台运营数据是指您（及您的用户）在本平台使用服务、您（及您的用户）'
            + '基于本平台服务而开发的产品或与本平台服务相关的产品中产生的全部或任何数据，包括但不限于您（及您'
            + '的用户）向本平台提交的数据、您（及您的用户）的使用或操作行为生成的数据及各类交互数据等。“平台'
            + '运营数据”的所有权及其他相关权利均属于百度，且是百度的商业秘密，除非相关法律法规明确规定属于您'
            + '（或您的用户）的合法相关权利。';
        const intellPropAndData7 = '7. 用户数据：是指用户在短网址平台、应用等中产生的与用户相关的数据，'
            + '包括但不限于用户提交的网址数据、域名数据、用户操作行为形成的数据、短信数据等。"用户数据"的所有'
            + '权及其他相关权利属于百度，且是百度的商业秘密，依法属于用户享有的相关权利除外。您的应用或服务对'
            + '于用户数据的收集、保存、使用等必须满足以下要求：';
        const intellPropAndData71 = '• 您的应用或服务需要收集用户任何数据的，必须事先获得用户的明确同意，'
            + '且仅应当收集为应用程序运行及功能实现目的而必要的用户数据，同时应当告知用户相关数据收集的目的、'
            + '范围及使用方式等，保障用户知情权。';
        const intellPropAndData72 = '• 您采集的用户数据，应采取合理、安全的技术措施，确保其安全性，'
            + '并对自己的行为（包括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果'
            + '承担全部责任。\n';
        const intellPropAndData73 = '• 您在特定应用中收集的用户数据仅可以在该特定应用中使用，'
            + '不得将其使用在该特定应用之外或为其他任何目的进行使用，也不得以任何方式将其提供给他人。';
        const intellPropAndData74 = '• 您应当向用户提供修改、删除用户数据的方式，确保用户要求'
            + '删除其用户数据时可通过该方式自行操作完成，并确保相关数据被完全删除。\n';
        const intellPropAndData75 = '• 未经百度同意，您不得通过本服务收集、存储、抓取、获得或'
            + '要求用户提供包括但不限于本服务的信息内容、用户数据等百度认为属于敏感信息范畴的数据，'
            + '也不得将所合法获得的前述数据自行或提供给其用户、客户用于创建、补充或维护自身关系链。\n';
        const intellPropAndData76 = '• 未经百度允许，您不得利用本服务所获得的数据实施或变相实施'
            + '任何形式的推广、营销、广告行为。\n';
        const intellPropAndData77 = '• 如果百度认为您收集、使用用户数据的方式，可能损害用户体验，'
            + '百度有权要求您删除相关数据并不得再以该方式收集、使用用户数据。\n';
        const intellPropAndData78 = '• 百度有权限制或阻止您获取用户数据及本平台数据。\n';
        const intellPropAndData79 = '• 一旦您停止使用本服务，或百度基于任何原因终止您使用本服务'
            + '，您必须立即删除全部从本服务中获得的数据（包括各种备份），且不得再以任何方式进行使用\n';
        const privacyPolicyOverview1 = '百度十分重视用户信息的保护，百度将会采取合理措施保护您（及'
            + '您的用户）的隐私权。为了向您（及您的用户）提供更好的服务，您同意（并应取得您的用户事先同'
            + '意）并授权本平台基于服务必要性获取相应的信息和数据，不论是您（及您的用户）主动提供的还是'
            + '使用本服务过程中获取的信息和数据。 您（及您的用户）提供的信息和数据将用于改善百度的服务，'
            + '向您（及您的用户）提供更好的用户体验以及满足您（及您的用户）的需求等。';
        const privacyPolicyOverview2 = '如果您（或您的用户）不同意提供相关信息和数据，或您不保证在'
            + '您的用户知情、并授权允许的情况下使用本服务，您（或您的用户）将无法使用本服务的部分或者全部。'
            + '一旦您（及您的用户）选择使用本服务，即表示您认可（并已取得您的用户的事先认可）并接受本协议'
            + '中隐私政策的内容以及百度可能随时更新并公布的新内容。';
        const privacyPolicyOverview3 = '如因用户数据、用户肖像信息等应用造成您的直接用户的投诉、主张、'
            + '诉讼等纠纷，您应当负责自行处理并承担全部法律责任，同时应保证百度免于因此而遭受任何损失或损害'
            + '。如百度因任何政府决定、法院判决等对包括您及您的用户在内的任何人承担单独或连带赔偿责任的，您'
            + '应当对百度作出相应数额的补偿，以保证百度免于因此而遭受任何损失或损害。';
        const privacyPolicy2 = '在如下情况下，百度可能会披露您（或您的用户）的信息：（1）事先获得您（或您'
            + '的用户）的授权；（2）您（及您的用户）使用共享功能；（3）根据法律、法规、法律程序的要求或政府主'
            + '管部门的强制性要求；（4）以学术研究或公共利益为目的；（5）为维护百度的合法权益，例如查找、预防、'
            + '处理欺诈或安全方面的问题；（6）符合相关服务条款或使用协议的规定；（7）以无法合理被用于识别您（及'
            + '您的用户）身份的汇总和/或匿名的形式分享您（及您的用户）的信息。';
        const privacyPolicy3 = '百度非常重视信息安全，百度成立了专责团队，研发和应用多种安全技术和程序等，'
            + '通过这些严格措施努力保护您的信息不被未经授权的访问、使用或泄漏。维护本服务的安全与正常使用是百'
            + '度和您（及您的用户）的共同责任，百度将采取适当的安全措施和技术手段维护本服务，但是您充分理解并'
            + '同意（并应促使您的用户充分理解并同意），百度并不能就此提供完全保证。';
        const exceptionAndLimitation1 = '1. 如果百度发现或收到他人举报或投诉您（或您的用户）违反本协议约定的，'
            + '百度有权根据您（或您的用户）的行为性质，采取包括但不限于暂停或终止本服务、追究法律责任等措施。\n';
        const exceptionAndLimitation2 = '2. 您充分理解并同意（并应促使您的用户充分理解并同意），百度有'
            + '权依合理判断对违反有关法律法规或本协议规定的行为进行处理，对您（或您的用户）的违法违规行为采取'
            + '适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。\n';
        const exceptionAndLimitation3 = '3. 您充分理解并同意（并应促使您的用户充分理解并同意），因您'
            + '（或您的用户）违反本协议或相关法律法规的规定，导致或产生第三方主张的任何索赔、要求或损失，'
            + '您应当独立承担责任，并保证百度免于因此遭受任何损失；百度因此遭受损失的，您应当向百度承担'
            + '全部赔偿责任。您同意（并应取得您的用户的事先同意）百度及其分支机构、联属机构、管理人员、'
            + '代理机构、员工、广告客户、许可证颁发机构、供应商或合作伙伴免受任何第三方由于您（及您的用户）'
            + '使用本服务、违反本协议或任何其他相关行为而导致或在任何方面与之相关的索赔，您（及您的用户）'
            + '承担全部的责任并赔偿百度一切种类与性质的费用，包括所有索赔、损失、损害（实际和继发损害）、'
            + '诉讼、判决、诉讼费和律师费。在此情况下，百度会向您（或您的用户）提供有关此类索赔要求或诉讼'
            + '的书面通知。在所有情况下，百度对于任何不能合理预见的损失或损害不承担责任。\n';
        const exceptionAndLimitation4 = '4. 您承认（并应促使您的用户承认），您（或您的用户）若'
            + '违反法律法规或本协议，将会给百度造成无法弥补的损害且损害程度将难以确定。您充分理解并同'
            + '意（并应促使您的用户充分理解并同意），如果因为您（或您的用户）违反法律法规或本协议而导'
            + '致百度、其他用户或任何第三方造成损害，引起任何和全部索赔、请求、损失、责任和费用，您（'
            + '及您的用户）应当自行承担因此产生的全部后果和损失，包括但不限于罚款、赔偿金、诉讼费、律'
            + '师费等，百度对此不承担任何责任。\n';
        const exceptionAndLimitation5 = '5. 您了解并同意（并应促使您的用户了解并同意）您（及您'
            + '的用户）将自行承担使用本服务的所有风险。本服务明确声明，不提供任何明示或默示的担保和保'
            + '证，包括但不限于：\n';
        const exceptionAndLimitation6 = '6. 任何通过本服务下载或以其他方方式获得的资料均属您'
            + '（及您的用户）个人所为，您（或您的用户）单方承担下载这类资料可能会损坏您（或您的用户）'
            + '计算机系统或丢失数据的风险。您（及您的用户）从本平台或通过本服务得到的任何建议或信息，'
            + '无论是口头还是书面信息，均不得作为本协议中未明确声明事项的担保和保证。\n';
        const exceptionAndLimitation7 = '7. 您明确理解并同意（并应促使您的用户理解并同意）百'
            + '度将不对由以下原因导致的直接、间接、偶然、特殊、继发性或惩罚性损失负责，包括但不仅限'
            + '于利润、声誉、使用、数据方面的损失或其他无形损失（即使已向百度告知了发生此类损害的可能性）：\n';
        const exceptionAndLimitation8 = '8. 您充分理解并同意（并应促使您的用户充分理解并同意），'
            + '本服务可能会受到多种因素影响，包括但不限于您（或您的用户）的原因、网络设备维护、网络连'
            + '接故障、网络信号未覆盖、网络传输延时或中断、电子终端、通讯或其他系统的故障或误差、电力'
            + '故障、罢工、劳动争议、暴乱、骚乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关'
            + '的命令、其他不可抗力、第三方恶意使用、第三方的不作为等不可抗力；本服务也可能受到各种安全'
            + '问题的侵扰，例如您（或您的用户）下载安装的其他软件或访问的其他网站中含有病毒、木马或其'
            + '他恶意程序，威胁到您（或您的用户）的设备和数据安全，进而影响本服务的使用等。除法律法规'
            + '明确规定要求百度承担责任之外，因本款所述原因给您（或您的用户）造成的任何损失由您（或您'
            + '的用户）本人自行承担，百度对此不承担责任。\n';
        const exceptionAndLimitation9 = '9. 您充分理解并同意（并应促使您的用户充分理解并同意），'
            + '您（或您的用户）使用本服务进行的任何相关行为所产生的任何义务、责任和后果应由您（及您的用'
            + '户）自行承当，您（及您的用户）的任何管理人员、雇员或其他代理人的行为，视为您（或您的用户）'
            + '的行为，由此产生的所有义务、责任和后果同样由您（及您的用户）自行承担。如果您（或您的用户）'
            + '代表其他主体使用本服务进行网站或应用程序开发，而您（或您的用户）未告知其他主体本协议的存在'
            + '并获得其书面同意的，您（及您的用户）对该等主体使用本服务进行的任何相关行为所产生的任何义务、'
            + '责任和后果承担连带责任。\n';
        const serviceUpdate1 = '1. 百度有权随时自行选择发出或者不发出通知，以变更、中断或终止提供本'
            + '服务，也有权自行选择变更、中断或终止您（或您的用户）对本服务的使用。如因服务器或系统的维护、'
            + '升级需要或其他原因需要暂停或终止本服务的全部或者部分内容，百度将尽可能事先公告。如果百度永'
            + '久终止提供本服务，百度将在本服务终止前提前在相关软件或网站上公告，您同意（并应取得您的用户'
            + '的事先同意）百度无需单独通知您（或您的用户）。除法律法规明确要求百度承担责任之外，百度无需'
            + '因本服务的任何变更、中断和终止向您或者任何第三方承担任何责任。\n';
        const serviceUpdate2 = '2. 如您（或您的用户）停止访问本平台或使用本平台服务，或本平台终止向'
            + '您（或您的用户）提供服务，您必须（并应促使您的用户必须）立即删除全部从平台中获得的数据（包'
            + '括各种备份），且不得再以任何方式进行使用。\n';
        const serviceUpdate3 = '3. 您应（并应促使您的用户应当）自行对因使用本服务而存储在百度服务器'
            + '的各类数据等信息，在本服务之外，采取合理、安全的技术措施，确保其安全性，并对自己的行为（包'
            + '括但不限于自行安装软件、采取加密措施或进行其他安全措施等）所引起的结果承担全部责任。\n';
        const deadlineAndTermination1 = '1. 本协议的生效日期应为您（及您的用户）同意本协议或使用本服'
            + '务之日中的较早日期，并且无固定期限，除非根据以下情形而终止';
        const deadlineAndTermination2 = '2. 您（及您的用户）和百度都可以不需任何理由终止本协议。如果您'
            + '（或您的用户）需要终止本协议，您（或您的用户）必须先将本服务从网站或应用中移除，并删除本平台提'
            + '供的一切数据（包括但不限于所有数据、域名等以及本平台标志）。\n';
        const deadlineAndTermination3 = '3. 本协议由于任何原因终止时，您（及您的用户）根据本协议所获得'
            + '的一切权利及许可全部同时终止。届时，您（及您的用户）将无法继续使用本服务的任何部分。\n';
        const deadlineAndTermination4 = '4. 您充分理解并同意（并应促使您的用户充分理解并同意），'
            + '本协议终止后，百度将继续保存通过本服务收集的所有信息和数据，并根据本协议使用。\n';
        const deadlineAndTermination5 = '5. 在本协议终止后，百度仍然可以依据相关法律法规及本协议'
            + '向您（或您的用户）追究违反法律法规或违反本协议行为的责任，本协议中关于个人信息保护、知识'
            + '产权、担保与保证、责任承担、免责及责任限制、法律适用和争议解决的条款始终有效。\n';
        const deadlineAndTermination6 = '6. 除法律法规明确规定要求百度承担责任之外，百度无需'
            + '因本协议或本服务的终止而需向您（或您的用户）或任何第三方承担责任。\n';
        const disputeSolution1 = '1. 本协议的订立、效力、解释、履行、修改和终止，访问和使用本服'
            + '务以及争议的解决均适用中华人民共和国（仅为本协议之目的，不包括香港、澳门和台湾）法律。\n';
        const disputeSolution2 = '2. 因访问和使用本服务而发生的任何争议，各方应首先通过友好协商'
            + '的方式加以解决。协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。因访问和使用本'
            + '服务而发生任何争议或任何争议正在进行诉讼时，除争议的事项外，各方仍应继续行使各自的其他'
            + '权利并履行各自的其他义务。\n';
        const others1 = '您充分理解并同意（并应促使您的用户充分理解并同意），百度就有关本服务的任何'
            + '通知可通过如下任一途径向您（或您的用户）发送：在软件及网站张贴一般通知；向您（或您的用户）'
            + '提供的电子邮件地址发送电子邮件；向您（或您的用户）提供的移动通讯号码发送短信通知；向您（'
            + '或您的用户）提供的通讯地址以平信形式寄送书面通知。前述通知自发布或发送之日即视为已经对您'
            + '（或您的用户）送达，您（及您的用户）有义务查收任何上述通知。\n';
        const others2 = '如果本协议的任何约定与适用的法律法规冲突的，以适用的法律法规的规定为准。'
            + '如本协议中的任何约定无论因何种原因无效或不可执行，其在不影响其他约定的情况下从本协议中'
            + '被移除，各方应以具有相同效果的有效、可执行的且最能体现本协议内容和意图的条款（或部分）'
            + '予以替换。本协议中的其余约定仍应保持有效并且具有完全的法律拘束力。\n';
        const others3 = '未经百度的事先书面同意，您（及您的用户）不得向任何第三方转让本协议及其'
            + '项下的任何权利和义务。百度有权随时在未取得您（及您的用户）同意的情况下向以下各方全部'
            + '或部分地转让本协议：（1）百度的子公司或者关联方；（2）百度的公司股权、业务或资产的收'
            + '购方；或者（3）并购交易中的继承人。任何违反本协议的转让行为均是无效的。\n';
        const others4 = '本协议（包括补充协议、附加条款及其他相关条款）构成您（及您的用户）与百'
            + '度之间就访问和使用本服务的全部协议和理解，并取代您（及您的用户）与百度先前存在的关于'
            + '前述问题的任何及全部的协议或理解。\n';
        const others5 = '除非百度以书面方式确认并同意，百度未履行本协议中任何权利或条款的行为'
            + '不构成百度对相关权利或条款的放弃。\n';
        const others6 = '本协议中的所有标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义'
            + '解释的依据。\n';
        const others7 = '关于本协议的问题，您（及您的用户）可以通过如下联络方式同百度联系： '
            + '中国北京市海淀区上地十街10号 北京百度网讯科技有限公司法务部 邮政编码：100085\n';
        return (
            <div className="doc-container">
                <div className="sla-content">
                    <p>欢迎您使用百度短网址服务（以下简称“本服务”）！</p>
                    <h2 className="title">一、特别提示</h2>
                    <p>{specialTip1}</p>
                    <p>{specialTip2}</p>
                    <p>{specialTip3}</p>
                    <h2 className="title">二、使用短网址服务</h2>
                    <h3>1. 服务介绍</h3>
                    <p>{serviceIntroDefine}</p>
                    <p>功能：
                        <br/>• 网址缩短功能：即是把长链接缩短成15个字符的短链接。
                        <br/>• 网址还原功能：即是把百度短网址生成的短链接，还原成原来的长链接。
                        <br/>• 提供简单易用的API：即提供网址缩短/还原的API接口。
                        <br/>• 提供可视化实时数据报表：即用户可在官网查看该账户累计缩短网址总数和累积跳转的总次数等。
                    </p>
                    <h3>2. 权利声明</h3>
                    <p>{rightDeclare}</p>
                    <h3>3. 终止服务</h3>
                    <p>{stopService}</p>
                    <h2 className="title">三、使用规则及限制</h2>
                    <p>{usePrinciple1}</p>
                    <p>2. 禁止行为<br/>{usePrinciple2}
                        <br/>(1) 删除本平台服务中包含的任何版权声明、商标声明或其他所有权声明；包括但不限于任何有损本平台一切相关知识产权的行为。
                        <br/>(2) 向任何第三方提交错误地明示或暗示向您提供的服务为百度所属、赞助或认可的内容等；
                        <br/>(3) 宣扬或提供关于非法行为的说明信息、宣扬针对任何团体或个人的人身伤害或传播任何病毒、蠕虫、缺陷、特洛伊木马或其他具有破坏性的内容等；
                        <br/>(4) 对本服务进行逆向工程、反编辑或试图从本服务或本服务相关内容的任何部分提取源代码，或获取原始数据和其他数据等；
                        <br/>(5) 对本服务或者本服务运行过程中释放出的任何数据或其他数据及本服务运行过程中的交互数据进行复制、更改、修改等操作，
                        包括但不限于使用插件、外挂或非经授权的第三方工具或服务接入本服务和相关系统；
                        <br/>(6) 创造任何网站或应用程序以重现或复制本服务或本平台。
                    </p>
                    <p>3. 遵守法律规范<br/>
                        您不得（并应促使您的用户保证不会）利用本服务上传、上载、发布、发表、传播任何违法内容，包括但不限于以下内容和行为：
                        <br/>(1) 反对宪法所确定的基本原则的；
                        <br/>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                        <br/>(3) 损害国家荣誉和利益的；
                        <br/>(4) 煽动民族仇恨、民族歧视、破坏民族团结的；
                        <br/>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；
                        <br/>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
                        <br/>(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                        <br/>(8) 侮辱或者诽谤他人，侵害他人合法权利的；
                        <br/>(9) 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵或其他道德上令人反感的内容；
                        <br/>(10) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其他内容的；
                        <br/>(11) 为任何非法目的而使用网络服务系统。
                    </p>
                    <p>4. 保障网络信息安全<br/>
                        您不得（并应促使您的用户保证不会）利用本服务从事以下危害计算机网络信息安全的活动：
                        <br/>(1) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；
                        <br/>(2) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；
                        <br/>(3) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
                        <br/>(4) 故意制作、传播计算机病毒等破坏性程序的；
                        <br/>(5) 其他危害计算机信息网络安全的行为。
                    </p>
                    <p>5. 服务的限制／收费<br/>
                        • {usePrinciple51}<br/>
                        • {usePrinciple52}<a href="/console/product" target="_self">https://dwz.cn/console/product</a>
                    </p>
                    <p>6. 链接转换规则<br/>{usePrinciple6}</p>
                    <p>{usePrinciple7}</p>
                    <h2 className="title">四、知识产权与数据</h2>
                    <p>{intellPropAndData1}</p>
                    <p>{intellPropAndData2}</p>
                    <p>{intellPropAndData3}</p>
                    <p>{intellPropAndData4}</p>
                    <p>{intellPropAndData5}</p>
                    <p>{intellPropAndData6}</p>
                    <p>{intellPropAndData7}<br/>
                        {intellPropAndData71}<br/>
                        {intellPropAndData72}<br/>
                        {intellPropAndData73}<br/>
                        {intellPropAndData74}<br/>
                        {intellPropAndData75}<br/>
                        {intellPropAndData76}<br/>
                        {intellPropAndData77}<br/>
                        {intellPropAndData78}<br/>
                        {intellPropAndData79}<br/>
                    </p>
                    <h2 className="title">五、隐私政策</h2>
                    <h3>1. 概述</h3>
                    <p>{privacyPolicyOverview1}</p>
                    <p>{privacyPolicyOverview2}</p>
                    <p>{privacyPolicyOverview3}</p>
                    <h3>2. 信息披露</h3>
                    <p>{privacyPolicy2}</p>
                    <h3>3. 信息保护</h3>
                    <p>{privacyPolicy3}<br/>
                        本服务同时遵循百度隐私权保护声明，您（及您的用户）可以访问以下地址查阅：
                        <a href="http://www.baidu.com/duty/yinsiquan.html" target="_blank">http://www.baidu.com/duty/yinsiquan.html</a>
                    </p>
                    <h2 className="title">六、免责及责任限制</h2>
                    <p>{exceptionAndLimitation1}</p>
                    <p>{exceptionAndLimitation2}</p>
                    <p>{exceptionAndLimitation3}</p>
                    <p>{exceptionAndLimitation4}</p>
                    <p>{exceptionAndLimitation5}
                        <br/>(1) 本服务将符合您（或您的用户）的实际或特定需求或目的；
                        <br/>(2) 本服务的准确性、完整性或及时性；
                        <br/>(3) 本服务将不受干扰、无中断、持续稳定或没有错误；
                        <br/>(4) 使用本服务获得的任何结果或资料的正确性或可靠性；
                        <br/>(5) 本服务中的任何错误、问题、故障都将得到更正或解决；
                        <br/>(6) 经本服务购买或获得的任何产品、服务或其他内容符合您的期望；
                        <br/>(7) 本服务中第三方服务或外部链接及其指向的内容的准确性、稳定性和完整性；
                        <br/>(8) 您（及您的用户）提供给百度的信息不受任何侵害。
                    </p>
                    <p>{exceptionAndLimitation6}</p>
                    <p>{exceptionAndLimitation7}
                        <br/>(1) 您（或您的用户）使用或无法使用本服务；
                        <br/>(2) 由于通过本服务购买或获得任何商品、数据、信息或服务、接收讯息或参与交易而导致购买替代商品和服务的费用；
                        <br/>(3) 未经授权的访问或修改传输内容或数据；
                        <br/>(4) 任何第三方针对本服务下的短网址进行恶意点击或其他损害您利益的行为；
                        <br/>(5) 任何第三方有关本服务的声明或行为；或者与本服务有关的其他事宜。
                    </p>
                    <p>{exceptionAndLimitation8}</p>
                    <p>{exceptionAndLimitation9}</p>
                    <h2 className="title">七、服务的变更、中断和终止</h2>
                    <p>{serviceUpdate1}</p>
                    <p>{serviceUpdate2}</p>
                    <p>{serviceUpdate3}</p>
                    <h2 className="title">八、期限和终止</h2>
                    <p>{deadlineAndTermination1}
                        <br/>(1) 您（或您的用户）丧失民事权利能力或民事行为能力，或丧失其他主体的法律授权；
                        <br/>(2) 百度因为任何原因终止提供本服务；
                        <br/>(3) 您（或您的用户）不再使用本服务；
                        <br/>(4) 其他导致本协议终止的原因。
                    </p>
                    <p>{deadlineAndTermination2}</p>
                    <p>{deadlineAndTermination3}</p>
                    <p>{deadlineAndTermination4}</p>
                    <p>{deadlineAndTermination5}</p>
                    <p>{deadlineAndTermination6}</p>
                    <h2 className="title">九、争议解决</h2>
                    <p>{disputeSolution1}</p>
                    <p>{disputeSolution2}</p>
                    <h2 className="title">十、其他</h2>
                    <h3>1. 通知及送达</h3>
                    <p>{others1}</p>
                    <h3>2. 可分割性</h3>
                    <p>{others2}</p>
                    <h3>3. 转让</h3>
                    <p>{others3}</p>
                    <h3>4. 完整性</h3>
                    <p>{others4}</p>
                    <h3>5. 弃权</h3>
                    <p>{others5}</p>
                    <h3>6. 标题</h3>
                    <p>{others6}</p>
                    <h3>7. 联系我们</h3>
                    <p>{others7}</p>
                    <h3>8. 解释权</h3>
                    <p>百度在法律法规许可的范围内对协议条款享有解释权。<br/>
                        2019年7月17日
                    </p>
                    <h3></h3>
                    <h3></h3>
                    <h3></h3>
                </div>
            </div>
            );
    }
}
export default connect(state => ({
    currentPage: state.currentPage
}))(Service);
